export default function FormWarningMessengerDirective() {
        return {
            restrict: 'A',
            scope: {
                checkObject: '=ktFormWarningMessenger',
            },
            link: function(scope, element) {
                if (scope.checkObject) {
                    const formChecker = new FormWarningMessenger(
                        scope.checkObject.errorCheckers,
                        scope.checkObject.form
                    );

                    const messagesNode = getMessageElement();

                    assignWatchers(
                        getCollectionOfPropertiesToWatch(formChecker),
                        assignMessagesIfErrors(formChecker, messagesNode)
                    );
                }

                function getMessageElement() {
                    return element[0].querySelector(scope.checkObject.errorElementSelector);
                }

                function assignMessagesIfErrors(checker, messageElement) {
                    return function() {
                        checker.check();
                        assignErrors(checker.getMessages(), messageElement);
                    };
                }

                function assignErrors(messages, messageElement) {
                    if (messages.length) {
                        messageElement.style.display = 'block';
                        messageElement.innerHTML = '<div>' + messages.join('<br/><br/>') + '</div>';
                    } else {
                        messageElement.style.display = 'none';
                    }
                }

                function getCollectionOfPropertiesToWatch(formChecker) {
                    return function() {
                        const propertiesToWatch = [];

                        _.forEach(formChecker.errorCheckers, (property) => {
                            propertiesToWatch.push(_.get(formChecker.formObject, property.propertyName));
                        });

                        return propertiesToWatch;
                    };
                }

                function assignWatchers(getCollectionToWatch, assignErrorsFunction) {
                    scope.$watch(getCollectionToWatch, assignErrorsFunction, true);
                }
            },
        };
}

    class FormWarningMessenger {
        constructor(errorCheckers, formObject) {
            this.errors = [];
            this.formObject = formObject;
            if (_.any(errorCheckers, Array.isArray)) {
                this.errorCheckers = _.flatten(errorCheckers);
                return;
            }
            this.errorCheckers = errorCheckers;
        }

        check() {
            this.errors = [];
            _.forEach(this.errorCheckers, (checker) => {
                if (!angular.isFunction(checker.needToShowMessage)) {
                    throw new Error('Check has to be a function');
                } else if (!checker.needToShowMessage(_.get(this.formObject, checker.propertyName))) {
                        this.errors.push(checker.message);
                    }
            });
            return this;
        }

        getMessages() {
            return this.errors;
        }

        isValid() {
            return this.errors.length;
        }
    }



// WEBPACK FOOTER //
// ./src/app/directives/ktFormWarningMessenger.js